<template>
  <div class="orcamento-servico-page">
    <!-- OrcamentoServicoModal is centralized in ModalManager.vue - opened via eventBus -->
    <OrcamentoServicoTable ref="orcamentoServicoTableRef" />
  </div>
</template>

<script setup lang="ts">
// OrcamentoServicoModal is centralized in ModalManager.vue
import OrcamentoServicoTable from './OrcamentoServicoTable.vue';
</script>

<style scoped>
.orcamento-servico-page {
  /* Add styles here */
}
</style>
